import * as React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"
import 'bootstrap/dist/css/bootstrap.min.css'

import Map from "../components/Map/Map"
import useMapData from "../hooks/useMapData.js"

const MapPage = ({ location }) => {
	return (
		<Layout location={location}>
			<Seo title="Map of Worship Places in Singapore" />
			<Map location={location} data={useMapData()} />
		</Layout>
	)
}

export default MapPage
